module.exports = __webpack_public_path__ + "static/media/cost_compare.1ec7cedb.jpg";